// Lion mark — ported from design/project/screens/misc.jsx
// Fixed geometry in viewBox units so it scales linearly with `size`.
type Props = { size?: number; color?: string };

export function LionMark({ size = 32, color }: Props) {
  const c = color ?? 'var(--accent)';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke={c}
      strokeWidth={2.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0 }}
      aria-label="Lion Tracker"
    >
      <path d="M32 4 C36 4 40 7 42 11 C47 9 52 12 53 17 C57 17 60 21 60 25 C60 28 57 32 60 35 C60 39 57 43 53 43 C52 48 47 51 42 49 C40 53 36 56 32 56 C28 56 24 53 22 49 C17 51 12 48 11 43 C7 43 4 39 4 35 C7 32 4 28 4 25 C4 21 7 17 11 17 C12 12 17 9 22 11 C24 7 28 4 32 4 Z" />
      <path d="M18 18 q-1.5 -4 2 -5 q3.5 1.5 1 5" />
      <path d="M46 18 q1.5 -4 -2 -5 q-3.5 1.5 -1 5" />
      <circle cx="25" cy="30" r="1.6" fill={c} stroke="none" />
      <circle cx="39" cy="30" r="1.6" fill={c} stroke="none" />
      <path d="M29 35 L35 35 L32 39 Z" fill={c} stroke="none" />
      <path d="M32 39 q-2 4 -5 3 M32 39 q2 4 5 3" />
    </svg>
  );
}
